// extracted by mini-css-extract-plugin
export default {"box":"Customer_box__BTDKP","label":"Customer_label__4ZevE","input":"Customer_input__sNCei"};